export const AddRowButtonTestPageObject = (onAddInstance: () => void) => ({
    getType: () => "AddRowButton",

    addInstance: () => onAddInstance(),
});
